import { render, staticRenderFns } from "./Paybacks.vue?vue&type=template&id=2ab681e3"
import script from "./Paybacks.vue?vue&type=script&lang=js"
export * from "./Paybacks.vue?vue&type=script&lang=js"
import style0 from "./Paybacks.vue?vue&type=style&index=0&id=2ab681e3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports